import Footer from "./footerSelector";

export default Footer;
